import { Add } from "@mui/icons-material";
import { Button, Card, Grid, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";
import crsAcls from "src/careflow/ph-core/admin/permissions/util/crs/crsAcls";
import { checkAclValidation } from "src/careflow/ph-core/admin/permissions/util/permission.utils";
import { WrappedPatient } from "src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient";
import { useImmunizations } from "src/careflow/ph-core/fhir-client/fhir-react";
import useLocales from "src/careflow/ph-core/internationalization/hook/useLocales";
import SummaryTable from "src/components/SummaryTable";
import { mapImmunizationsToDisplay } from "src/careflow/common/common-utils";
import { STATUS_OPTION_IMMUNIZATION, TABLE_HEAD_IMMUNIZATIONS } from "src/careflow/common/table-head";
import { translateTableHead } from "src/careflow/helpers/common";
import ImmunizationAddForm from "./ImmunizationAddForm";

type Props = {
  patient: WrappedPatient | null;
};

export default function ImmunizationList ({ patient }: Props) { 
  const { enqueueSnackbar } = useSnackbar();
  const [openImmunization, setOpenImmunization] = useState(false);
  const { i18n } = useLocales();

  const [immunizations, { create: createImmunization, refresh: refreshImmunizations }] =
    useImmunizations({ filter: { patient: patient?.id } });

  const handleCloseAddImmunization = () => {
    setOpenImmunization(false);
  };

  const handleCreateImmunization = async (data: any) => {
    const result = await createImmunization(data);
    refreshImmunizations();
    enqueueSnackbar('Immunization created successfully!');
    handleCloseAddImmunization();
  };
  
  return (
    <>
      <Card style={{ boxShadow: 'none', position: 'static' }}>
        <Stack sx={{ m: 2, mt: 0 }}>
          <Grid container display={'flex'} alignItems={'center'} paddingRight={2}>
            {checkAclValidation({ acls: [crsAcls.CRS.PATIENT.IMMUNIZATION.ADD] }) && (
              <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ height: '36px' }}
                  startIcon={<Add />}
                  style={{ position: 'absolute', top: '25px', right: '25px' }}
                  onClick={() => setOpenImmunization(true)}
                >
                  {i18n('patients.details.immunizations.button', 'crs')}
                </Button>
              </Grid>
            )}
          </Grid>
        </Stack>

        <SummaryTable
          header={translateTableHead(TABLE_HEAD_IMMUNIZATIONS, i18n, 'crs')}
          data={mapImmunizationsToDisplay(immunizations)}
          statusList={STATUS_OPTION_IMMUNIZATION}
          sx={{ padding: 0 }}
        />
      </Card>
      <ImmunizationAddForm
        open={openImmunization}
        onCancel={handleCloseAddImmunization}
        handleCreateImmunization={handleCreateImmunization}
        patient={patient}
      />
    </>
  )
}